import { createAsyncThunk } from '@reduxjs/toolkit'

import { clearSession } from '@/entities/session'

import { performLogout } from './performLogout'

const API_RESET_ACTION_TYPE = 'api/resetApiState'

export const logout = createAsyncThunk('entities/user/logout', async (_, thunkApi) => {
	await performLogout()
	thunkApi.dispatch(clearSession())
	thunkApi.dispatch({ type: API_RESET_ACTION_TYPE })
})
